import { render, staticRenderFns } from "./Eventscenter.vue?vue&type=template&id=b29c9740&scoped=true"
import script from "./Eventscenter.vue?vue&type=script&lang=js"
export * from "./Eventscenter.vue?vue&type=script&lang=js"
import style0 from "./Eventscenter.vue?vue&type=style&index=0&id=b29c9740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29c9740",
  null
  
)

export default component.exports